import { useCallback } from 'react';

import { EnterVerificationCode } from '#src/components/settings/PhoneNumberVerification/EnterVerificationCode/index.tsx';
import { useVerifyPhoneNumber } from '#src/components/user/VerifyPhoneNumber/useVerifyPhoneNumber.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useWalletContext } from '#src/contexts/wallet/index.ts';

type Props = {
  unverifiedPhoneNumber: string;
  onSuccess: () => void;
  onCancel: () => void;
};
export const VerifyPhoneNumber = ({
  unverifiedPhoneNumber,
  onSuccess,
  onCancel,
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const verifyPhoneNumber = useVerifyPhoneNumber();

  const { checkUserPhoneNumberVerificationCodeWithRecovery } =
    useWalletContext();

  const submitVerificationCode = useCallback(
    async (verificationCode: any) =>
      checkUserPhoneNumberVerificationCodeWithRecovery(verificationCode),
    [checkUserPhoneNumberVerificationCodeWithRecovery]
  );

  if (!currentUser) return null;
  return (
    <EnterVerificationCode
      resendVerificationCode={async () =>
        verifyPhoneNumber(unverifiedPhoneNumber).then(res => res || [])
      }
      phoneNumber={unverifiedPhoneNumber}
      submitVerificationCode={submitVerificationCode}
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
};
